document.addEventListener('DOMContentLoaded', function() {
    const userAgent = navigator.userAgent;
    const isIPad = ((/iPad/.test(navigator.userAgent)) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
    if (isIPad){
       // Mobile or Tablet device
        document.body.classList.add('device-mobile');
    } else if (/Mobi|Android|iPhone|iPad|iPod/i.test(userAgent)) {
        // Mobile or Tablet device
        document.body.classList.add('device-mobile');
    } else {
        // Desktop device
        document.body.classList.add('device-desktop');
    }
});

// $('.quick-add__submit').each(function(index, item){
  // $('.quick-add__submit').on('click', function(e){
  $('body').on('click', '.quick-add__submit', function(e) {
//alert("test");
    e.preventDefault();
    // console.log('called', $(this).attr('data-variant-id'));
    $('.loader-sec').show();

     

// 8-11-2022 changes 
    let qty_tot = 0;
    let demoFound = false;
       $('.cart-drawer-min .cdmset').each(function(index,item){
        let dataitem = $(this).attr('data');
        if(dataitem){
          // if(var_tit.match("^DEMO") && (dataitem == 'DEMO'|| dataitem == 'demo')){
          if((dataitem == 'DEMO'|| dataitem == 'demo'|| dataitem == 'Demo')){
            demoFound = true;
            // console.log($(this).find('quantity-input').find('input').val())
            qty_tot = qty_tot + parseInt($(this).find('quantity-input').find('input').val());
          }
        }
      });
      // console.log('qty_tot', qty_tot)
    // return false;
    if ((!demoFound) && ($('.cart-count-bubble [data-cart-count]').text() != 0)) {
      setTimeout(function () {
      $('body').addClass('demoapi_cart-pop');
         $("body").addClass("active-popup");
          $(".cdel").addClass("show-cdel");
      }, 500);

      $('.loader-sec').hide();
     
     
      
    } else {
    data = {
        "id": $(this).attr('data-variant-id'),
        "quantity": 1
      }
    var temp = $(this);
    if (qty_tot >= 4) {
        $('.loader-sec').hide();
       $(".cdelmax").addClass("show-cdel-max");
        $(".cdelmax .max-info").show();
        $(".cdelmax .demo-program").hide();
        $("body").addClass("active-popup");
    } else {
     $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: data,
      success: function() {
        // console.log('suuceess');
        min_cart();
        
        setTimeout(function() {
          $('.cart-drawer').addClass("cart-dra-opp");
          $("body").addClass("active-popup");

          $.getJSON("/cart.js", function(cart) {
          $(".count-item-carts").text(cart.item_count);

          $(".cart-drawer-min .bold_line_properties").each(function(){ 

      $(this).find("span.bold_line_value").each(function(){ 
          var opt_val = $(this).text();
          if(opt_val == 'add_a_grip'){
            
            $(this).closest("div").css("display","none");
          }
      });
      
    });

          $(".cart-count-bubble span").text(cart.item_count);
          if (cart.item_count > 0) {
            $(".header__icon--cart .cart-count-bubble").removeClass('hide');
          } else {
            $(".header__icon--cart .cart-count-bubble").addClass('hide');
          }
          });
          
          var total_cart_item = 0;
          total_cart_item = $("#CartDrawer").find(".count-item-carts").text();
      // console.log('total_cart_item', total_cart_item)
          if(total_cart_item > 4){
            var real_cart_item = 4;
          }else{
            var real_cart_item = total_cart_item;
          }
          $('.loader-sec').hide();
        },2000);
      },
      // error: addToCartFail
   });
    }
    }
  });
  // });



  // filter issue in mobile
  $('.mobile-facets__close').on('click', function() {
    //console.log('clicked');
       $('body').removeClass('overflow-hidden-mobile');
       $('details.mobile-facets__disclosure').removeAttr('open').removecClass('menu-opening');
   });


  //  update price
   $("#Variants li input").on( "click", function() {
    var newprice = $(this).attr("data-price");
    $(".main-price").text( newprice );
  });



  // Show more show less in PDP page
  $(document).ready(function() {

    wow = new WOW(
    {
      animateClass: 'animated',
      offset:       100,
      animationDelay: '0.5s',
      callback:     function(box) {
      //console.log("WOW: animating <" + box.tagName.toLowerCase() + ">")
      }
    }
    );
    wow.init();
    

    var urlParams = new URLSearchParams(window.location.search); //get all parameters
    var opencart = urlParams.get('opencart'); //extract the foo parameter - this will return NULL if foo isn't a parameter

    if(opencart) { //check if foo parameter is set to anything
        setTimeout(function() {
                  $('.cart-drawer').addClass("cart-dra-opp");
          $("body").addClass("active-popup");
          $("body").addClass("drawer_open");
              }, 500);
    }

    // Configure/customize these variables.
    var showChar = 150;  // How many characters are shown by default
    var ellipsestext = "...";
    var moretext = "Show more";
    var lesstext = "Show less";
    

    // $('.product__accordion .accordion__content p').each(function() {
    //     var content = $(this).html();
 
    //     if(content.length > showChar) {
 
    //         var c = content.substr(0, showChar);
    //         var h = content.substr(showChar, content.length - showChar);
 
    //         var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span><a href="javascript:void(0);" class="morelink">' + moretext + '</a></span>';
 
    //         $(this).html(html);
    //     }
 
    // });
 
    $(".morelink").click(function(){
        if($(this).hasClass("less")) {
            $(this).removeClass("less",1000, "easeInBack");
            $(this).html(moretext);
        } else {
            $(this).addClass("less",1000, "easeInBack");
            $(this).html(lesstext);
        }
        $(this).parent().prev().toggle();
        $(this).prev().toggle();
        return false;

         // $(".morecontent").find("span").first().show(500);
        // $(".morecontent").parents("p").animate({height:$(".morecontent").parents("p").height()},2000);

    });

    demoProductCount();

    function demoProductCountCheck() {
      let qty_tot = 0;
       $('.cart-drawer-min .cdmset').each(function(index,item){
        let dataitem = $(this).attr('data');
        if(dataitem){
          // if(var_tit.match("^DEMO") && (dataitem == 'DEMO'|| dataitem == 'demo')){
          if((dataitem == 'DEMO'|| dataitem == 'demo'|| dataitem == 'Demo')){
            // demoFound = true;
            // console.log($(this).find('quantity-input').find('input').val())
            qty_tot = qty_tot + parseInt($(this).find('quantity-input').find('input').val());
          }
        }
      });
    }
  /*-- Add cart count bubble class --*/
   /* setTimeout(function () {
    $('.cart-count-init').addClass('cart-count-bubble');
  }, 3500);*/
  /*-- EOF Add cart count bubble class --*/
});

function check_demo_cart() {
  // console.log("addedtocart");
   let qty_tot = 1;
    $(this).css("display","block");
    $('ul#product-grid li').each(function(){
                var prod_title = $(this).find("h3.card__heading.h5.main_title").attr("data-title");
               var remove_prod = false;
                $('div#recommend_demo ul#product-grid li').each(function(){

                  var recomd_title = $(this).find("h3.card__heading.h5.main_title").attr("data-title");
                  //alert(recomd_title);
                //  console.log(recomd_title+'-'+prod_title);   
                    if(recomd_title == prod_title){
                       remove_prod = true;
                     // alert(remove_prod);
                    }
                  });
                if(remove_prod){
                  $(this).css("display","none");
                }

    
    });

     var mycatArray = [];
     
     ComparederReInit();

      var found_prod = 0;
      var checkedcol = false;
    $("ul#product-grid li").each(function(){  
          var product_cats = $(this).attr('prod_collection');
          var showproduct = false;
          $(this).css("display","none");
          var checkedcat = true;
          $("ul#filter_by_cat input").each(function(){  
            if($(this).prop("checked")){
              var catid = $(this).val();
              mycatArray.push(catid);
              if(product_cats.indexOf(catid) != -1){
                showproduct = true;
                 
              }
              checkedcol = true
              checkedcat = false;
            }
          }); 

          if(checkedcat){
            $(this).css("display","block");
          }
          if(showproduct){
            found_prod++;
            $(this).css("display","block");
          }
          //alert(product_cats+'--'+catid);
          
    });  
     if(found_prod == 0 && checkedcol){
        if(!$("div#ProductGridContainer").find(".collection.collection--empty.page-width").length){
          if(!$("div#ProductGridContainer").find(".emptycat_data").length){
            $("div#ProductGridContainer .collection").append('<div class="collection collection--empty page-width emptycat_data" id="product-grid"><div class="title-wrapper center"><h2 class="title title--primary">No products found<br>Use fewer filters or <a class="underlined-link link" href="'+window.location.pathname+'">remove all</a></h2></div></div>');
          }
        }
      }

      $(".facets-container").removeClass("overlay-fil");
    
}

window.ComparederModalCallback = function(eventType, processCompleted){
  if(eventType === 'open' && processCompleted === true){
    $("h2.pyr-compare-poptitle").text("Product Comparison");
    const compareMetafieldsTr = document.querySelectorAll('.pyr-compare-metafield');
    if(!compareMetafieldsTr.length)
      return false;

    compareMetafieldsTr.forEach(function(compareMetafieldTr){
      var compareMetafieldsTd = compareMetafieldTr.querySelectorAll('td');
      if(compareMetafieldsTd.length){
        if(compareMetafieldsTd[0]){
          if(compareMetafieldsTd[0].textContent === 'Section1 Specification Description'){
            compareMetafieldsTd[0].textContent = 'Specs & Description';
          }
          if(compareMetafieldsTd[0].textContent === 'Variant Title'){
            compareMetafieldsTd[0].textContent = 'Grip Size';
          }
         
          if(compareMetafieldsTd[0].textContent === 'Section1 Features Description'){
            compareMetafieldsTd[0].textContent = 'Features';
          }

          }
          const texther = '';
          if (compareMetafieldsTd[1]) {
            let truevar = compareMetafieldsTd[1].textContent;
            if (truevar.includes(":true")) {
                const truevararray = truevar.split(',');
                var true_arr_text = '';
                truevararray.forEach(function (item, index) {
                    if (item.indexOf(':true') != -1) {
                        var tru_val = item.split(':');
                        tru_val[0] = tru_val[0].substr(0, 1).toUpperCase() + tru_val[0].substr(1)
                        if (true_arr_text == '') {
                            true_arr_text = true_arr_text + tru_val[0];
                        } else {
                            true_arr_text = true_arr_text + ', ' + tru_val[0];
                        }
                    }
                });
                compareMetafieldsTd[1].textContent = true_arr_text;
            }
        }
      }
   
    });

     $('table.pyr-compare-table tr').each(function(){
        var trtitle = $(this).find("td:first").text();
        if(trtitle == 'Variant Title'){
          $(this).find("td:first").text('Grip Size');
        }
     });

      $('table.pyr-compare-table td').each(function(){
        var trtitle = $(this).text();
        if(trtitle == '$0'){
          $(this).text('DEMO');
        }
     });

 


  }
};
$(window).on('load', function() {
  
  $("div#FacetsWrapperDesktop details").each(function(){  
      var fieldtitle = $(this).find("legend.visually-hidden").text();
      if(fieldtitle == 'More filters'){
        //$(this).css("opacity","0");
          var hide_more = true;
        $("ul.list-unstyled.no-js-hidden li").each(function(){  
            var lititle = $(this).find("input").val();
            if(lititle == 'Best Seller' || lititle == 'New Release' || lititle == 'Sale'){
              //$(this).css("opacity","0");
              hide_more = false;
            }
        });
         // alert(hide_more);
        if(hide_more){
          $(this).css("display","none");
        }

      }

  });



 $("h2.pyr-compare-poptitle").text("Product Comparison");
  
  $(".cart-drawer-min .bold_line_properties").each(function(){ 

    $(this).find("span.bold_line_value").each(function(){ 
        var opt_val = $(this).text();
        if(opt_val == 'add_a_grip'){
          
          $(this).closest("div").css("display","none");
        }
    });
    
  });

});


$(document).ready(function() {

  $("div#FacetsWrapperDesktop details").each(function(){  
      var fieldtitle = $(this).find("legend.visually-hidden").text();
      if(fieldtitle == 'More filters'){
        //$(this).css("opacity","0");
          var hide_more = true;
        $("ul.list-unstyled.no-js-hidden li").each(function(){  
            var lititle = $(this).find("input").val();
            if(lititle == 'Best Seller' || lititle == 'New Release' || lititle == 'Sale'){
              //$(this).css("opacity","0");
              hide_more = false;
            }
        });
         // alert(hide_more);
        if(hide_more){
          $(this).css("display","none");
        }

      }
  });






  function validatePhone(txtPhone) {
    var a = txtPhone;
    var filter = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
    if (filter.test(a)) {
        return true;
    }
    else {
        return false;
    }
}

  $('body').on('submit', 'form.cs-form-wrap', function() {
     var phonenumber =  $("form.cs-form-wrap input#phonenumber").val();
    // alert(phonenumber);
    // alert(validatePhone(phonenumber));
    if(phonenumber != ''){

     if (validatePhone(phonenumber)) {
            $(".element-group.cs-width-100.cst_phone").removeClass("has-error");
            $(".element-group.cs-width-100.cst_phone .help-block").html("");        
          }
        else {
              if(!$(".element-group.cs-width-100.cst_phone").hasClass("has-error")){
                $(".element-group.cs-width-100.cst_phone").addClass("has-error");
              }
            
            $(".element-group.cs-width-100.cst_phone .help-block").html('Invalid Phonenumber.');
            return false;
        }
    }
  });

  $('body').on('change', 'ul#filter_by_cat input', function() {
    //$("button#gsloadmore").click();
   // return false;
    var changecat = $(this).val();
    var mycatArray = [];
     if($("div#gscollectionbottom").find("button#gsloadmore").length){
     //  alert("hasbutton");
      $("button#gsloadmore").click();
    }else{
      var found_prod = 0;
      var checkedcol = false;
      $("ul#product-grid li").each(function(){  
          var product_cats = $(this).attr('prod_collection');
          var showproduct = false;
          $(this).css("display","none");
          var checkedcat = true;
          $("ul#filter_by_cat input").each(function(){  
            if($(this).prop("checked")){
              var catid = $(this).val();
              mycatArray.push(catid);
              if(product_cats.indexOf(catid) != -1){
                showproduct = true;   
                 
              }
              checkedcol = true
              checkedcat = false;
            }
          }); 

          if(checkedcat){
            $(this).css("display","block");
          }
          if(showproduct){
            found_prod++;
            $(this).css("display","block");
          }

          //alert(product_cats+'--'+catid);
          
    });  

       if(found_prod == 0 && checkedcol){
        if(!$("div#ProductGridContainer").find(".collection.collection--empty.page-width").length){
          if(!$("div#ProductGridContainer").find(".emptycat_data").length){
            $("div#ProductGridContainer .collection").append('<div class="collection collection--empty page-width emptycat_data" id="product-grid"><div class="title-wrapper center"><h2 class="title title--primary">No products found<br>Use fewer filters or <a class="underlined-link link" href="'+window.location.pathname+'">remove all</a></h2></div></div>');
          }
        }
      }
      //alert(found_prod);
    }

    $(".facets-container").removeClass("overlay-fil");

    
    //$("button#gsloadmore").click();
    return false;
  //  alert(mycatArray);
  });


  $("textarea#Cart-note").keyup(function(){
  var newnote = $(this).val();
  $("textarea#Cart-note").attr("current_note",newnote);
  jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
    
       "note": newnote,
   
  });
});

  $('body').on('click', '.card__media.click_demo_popup', function() {
    $(this).closest(".card__inner").find(".variant-popup-btn").click();
  });

$('body').on('click', 'span.show_desc', function() {
    $(this).closest(".description").css("display","none");
    $(this).closest(".right-content").find(".description.full_content").css("display","block");
  });

$('body').on('click', 'span.hide_desc', function() {
    
    $(this).closest(".right-content").find(".description").css("display","block");
    $(this).closest(".description.full_content").css("display","none");
  });

  $('body').on('click', 'svg.notcheckedicon', function() {
    $("input#note_check").prop("checked",true);
    var oldnote = $("textarea#Cart-note").attr("current_note");
                //$("textarea#Cart-note").text(oldnote);
               $(".extranote").css("display","block");
  });

   $('body').on('click', '.checkedicon', function() {
    $("input#note_check").prop("checked",false);
    $("textarea#Cart-note").text("");
                jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
    
                      "note": "",
       
                });

                $(".extranote").css("display","none");
  });


$('body').on('click', 'input#note_check', function() {
 
              if($(this).prop("checked") == true) {
               // alert("checked");
                var oldnote = $("textarea#Cart-note").attr("current_note");
                //$("textarea#Cart-note").text(oldnote);
               $(".extranote").css("display","block");
              }
              else if($(this).prop("checked") == false) {
                // alert("unchecked");
                $("textarea#Cart-note").text("");
                jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
    
                      "note": "",
       
                });

                $(".extranote").css("display","none");
              }
 });




var newdeviceWidth = $(window).width();
var newdeviceheight = $(window).height();
//alert(newdeviceheight);
if(newdeviceheight <= 700){
  $("li.data-all-subchild a").css("font-size","18px");
  $("li.data-all-subchild a").css("padding","10px 0px");
}

if(newdeviceWidth <= 767){
 // alert(newdeviceWidth);
  
  $('body').on('click', 'ul.menu-drawer__menu.list-menu.tst li', function() {
   // alert("test");
    //$(this).css("display","flow-root");
   
    
    if($(this).hasClass("opened_forth")){
       //$('ul.menu-drawer__menu.list-menu.tst li').each(function(){
               $(this).find("div.newgrandchild.secondchild").css("display","none");
                $(this).find("span.arrow-header-right").css("display","none");
              $(this).removeClass("opened_forth");
              $(this).find("svg.icon.icon-arrow.forthinner.openchild").css("display","block");
               $(this).find("svg.close_child").css("display","none");

              /* $('ul.menu-drawer__menu.list-menu.tst li').each(function(){
               $(this).find("div.newgrandchild.secondchild").css("display","none");
                 $(this).find("span.arrow-header-right").css("display","none");
                  $(this).removeClass("opened_forth");
                  $(this).find("svg").css("display","block");

              });*/

      // });
     
    }else{
      $(this).find("div.newgrandchild.secondchild").css("display","block");
     $(this).find("span.arrow-header-right").css("display","block");
      $(this).addClass("opened_forth");
       $(this).find("svg.close_child").css("display","block");
       $(this).find("svg.icon.icon-arrow.forthinner.openchild").css("display","none");
    }
     
  });
}else{
  var grandchild_width = $("ul.grandchild").width();
//alert(grandchild_width);
var newsuperchild_width = grandchild_width+"px";
$(".second_layer_menu").css("left",grandchild_width);
}

 /*$("ul.grandchild").hover(function(){
  $('ul.child li.data-all-child.hide-list.list-menu__item.active.child-active.show-list').each(function(index,item){
     
     $(this).find(".second_layer_menu").html("");
     
    });
 });*/

  $("ul.grandchild li span.title-menus.grandchild").hover(function(){
    var  runfinal = $(this);
     $(".second_layer_menu").html("");
    $('ul.child li.data-all-child.hide-list.list-menu__item.active.child-active.show-list').each(function(index,item){
     
     $(this).find(".second_layer_menu").html("");
     
    }).promise().done( function(){ 

      $('.side-draver-desk.show-drawer ul.grandchild li').each(function(){
               
      $(this).find("div.newgrandchild.secondchild").css("display","none");
     //$(this).find("span.arrow-header-right").css("display","none");

       });
      $(".side-draver-desk.show-drawer ul.grandchild li > a").removeClass("activehover");

   // alert("test");
    //$(this).css("display","flow-root");
   //  runfinal.closest("li").find("div.newgrandchild.secondchild").css("display","block");
     runfinal.closest("li").find("span.arrow-header-right").css("display","block");
     runfinal.closest("a").addClass("activehover");

     
     if(runfinal.closest("li").find("div.newgrandchild.secondchild").length){
      var child_html = runfinal.closest("li").find("div.newgrandchild.secondchild").html();
     runfinal.closest("li.data-all-child").find(".second_layer_menu").html('<div class="newgrandchild secondchild" style="display: block;">'+child_html+'</div>');
     }


    } );


  });

  if($("body").hasClass("demo-program")){

    var todayDate = new Date().toISOString().slice(0, 10);
    var dt1 = new Date(todayDate);
    //alert(todayDate);
    /*$('div#ProductGridContainer ul#product-grid li').each(function(index,item){
      if(!$(this).find(".tag_added").length){
         var created_date = $(this).find("span.tag-show").attr("created_date");
       if(created_date != ''){
          var dt2 = new Date(created_date);
          
           var time_difference = dt1 - dt2;
            var result = time_difference / (1000 * 60 * 60 * 24);
           
           if(result <= 90){
            
            var oldtext =  $(this).find("span.tag-show").attr("oldtag");
           
            var newString = oldtext;
          
            if(newString == 'BestSeller' || newString == 'Sale' || newString == 'Best Seller, Sale' || newString == 'Sale, Best Seller'){
              var newtext = newString+", New Release";
              $(this).find("span.tag-show").text(newtext);
            }else{
              $(this).find("span.tag-show").text("New Release");
            }
            $(this).find("span.tag-show").addClass("tag_added");
           }
           
        }

      }
     
      
        });*/

    $(window).scroll(function(){
      var todayDate = new Date().toISOString().slice(0, 10);
    var dt1 = new Date(todayDate);
    //alert(todayDate);
   /* $('div#ProductGridContainer ul#product-grid li').each(function(index,item){
      if(!$(this).find(".tag_added").length){
         var created_date = $(this).find("span.tag-show").attr("created_date");
       if(created_date != ''){
          var dt2 = new Date(created_date);
          
           var time_difference = dt1 - dt2;
            var result = time_difference / (1000 * 60 * 60 * 24);
           
           if(result <= 90){
            
             var oldtext =  $(this).find("span.tag-show").attr("oldtag");
          
            var newString = oldtext;

           
             if(newString == 'BestSeller' || newString == 'Sale' || newString == 'Best Seller, Sale' || newString == 'Sale, Best Seller'){
              var newtext = newString+", New Release";
              $(this).find("span.tag-show").text(newtext);
            }else{
              $(this).find("span.tag-show").text("New Release");
            }
            $(this).find("span.tag-show").addClass("tag_added");
           }
           
        }

      }
     
      
        });*/
      });
  }else if($("body").hasClass("template-collection")){
      var todayDate = new Date().toISOString().slice(0, 10);
    var dt1 = new Date(todayDate);
    //alert(todayDate);
  /*  $('div#ProductGridContainer ul#product-grid li').each(function(index,item){
      if(!$(this).find(".tag_added").length){
         var created_date = $(this).find("span.tag-show").attr("created_date");
       if(created_date != ''){
          var dt2 = new Date(created_date);
          
           var time_difference = dt1 - dt2;
            var result = time_difference / (1000 * 60 * 60 * 24);
           
           if(result <= 90){
            var oldtext =  $(this).find("span.tag-show").attr("oldtag");
           
            var newString = oldtext;
           
            if(newString == 'BestSeller' || newString == 'Sale' || newString == 'Best Seller, Sale' || newString == 'Sale, Best Seller'){
              var newtext = newString+", New Release";
              $(this).find("span.tag-show").text(newtext);
            }else{
              $(this).find("span.tag-show").text("New Release");
            }
            $(this).find("span.tag-show").addClass("tag_added");
           }
           
        }

      }
     
      
        });*/

    $(window).scroll(function(){
      var todayDate = new Date().toISOString().slice(0, 10);
    var dt1 = new Date(todayDate);
    //alert(todayDate);
    /*$('div#ProductGridContainer ul#product-grid li').each(function(index,item){
      if(!$(this).find(".tag_added").length){
         var created_date = $(this).find("span.tag-show").attr("created_date");
       if(created_date != ''){
          var dt2 = new Date(created_date);
          
           var time_difference = dt1 - dt2;
            var result = time_difference / (1000 * 60 * 60 * 24);
           
           if(result <= 90){
            var oldtext =  $(this).find("span.tag-show").attr("oldtag");
          
            var newString = oldtext;
          
           if(newString == 'BestSeller' || newString == 'Sale' || newString == 'Best Seller, Sale' || newString == 'Sale, Best Seller'){
              var newtext = newString+", New Release";
              $(this).find("span.tag-show").text(newtext);
            }else{
              $(this).find("span.tag-show").text("New Release");
            }
            $(this).find("span.tag-show").addClass("tag_added");
           }
           
        }

      }
     
      
        });*/
      });
  }

  setTimeout(function () {
    $('.MuiIconButton-label').prepend('<span id="new-remove"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"> <path fill-rule="evenodd" clip-rule="evenodd" d="M0.42606 0.425502C0.661059 0.190504 1.03253 0.18097 1.25577 0.404207L6.91467 6.0631C7.1379 6.28634 7.12837 6.65782 6.89337 6.89281C6.65837 7.12781 6.2869 7.13735 6.06366 6.91411L0.404765 1.25521C0.181527 1.03197 0.191062 0.660501 0.42606 0.425502Z" fill="black"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M6.31222 7.23367C6.07722 6.99867 6.07722 6.61766 6.31222 6.38266L12.2693 0.425631C12.5043 0.190632 12.8853 0.190632 13.1203 0.425631C13.3553 0.660629 13.3553 1.04164 13.1203 1.27664L7.16323 7.23367C6.92823 7.46867 6.54722 7.46867 6.31222 7.23367Z" fill="black"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M0.538784 13.0106C0.303785 12.7756 0.303785 12.3946 0.538784 12.1596L6.49582 6.20255C6.73082 5.96755 7.11182 5.96755 7.34682 6.20255C7.58182 6.43755 7.58182 6.81855 7.34682 7.05355L1.38979 13.0106C1.15479 13.2456 0.773782 13.2456 0.538784 13.0106Z" fill="black"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M7.59012 7.59249C7.82512 7.3575 8.22486 7.37623 8.48297 7.63434L13.5303 12.6817C13.7884 12.9398 13.8072 13.3396 13.5722 13.5746C13.3372 13.8096 12.9374 13.7908 12.6793 13.5327L7.63197 8.48535C7.37386 8.22724 7.35512 7.82749 7.59012 7.59249Z" fill="black"></path> </svg></span>');
  }, 2500);

  // default uncheck variant 
  // $('variant-radios .product-form__input input[type=radio]').prop('checked', false);

  // add new class if imte is 1
  if ($('.video-sec-all .video-sec-set.swiper-slide').length == 1) {
    $('.video-sec-all .video-sec-set.swiper-slide').addClass('single-new-class');
  }

});


$("ul.child li span.title-menus.cus-menu").hover(

 function () {

var hovefun = $(this);
  
  $('ul.child li.data-all-child.hide-list.list-menu__item.active.child-active.show-list').each(function(index,item){
      
     $(this).find(".second_layer_menu").html("");
     
    }).promise().done( function(){ //alert("test"); 
     $("ul.grandchild").css("transform","translateX(-30px)");
           $("ul.grandchild").css("transition","all 150ms");
           $("ul.grandchild").css("opacity","0");
           $("ul.grandchild").css("visibility","hidden");
           $("ul.grandchild").css("z-index","0");
           $("ul.parent li a").removeClass("activehover");



   hovefun.closest("li").addClass("result_hover_child");
    
    hovefun.closest("a").addClass("activehover");
          if ( hovefun.closest("li").find("ul.grandchild").length > 0 ) {
          //  alert("test"); 
        hovefun.parent('.side-draver-desk').addClass('haschildren');
         hovefun.closest("li").find("ul.grandchild").css("transform","translateX(0px)");
           hovefun.closest("li").find("ul.grandchild").css("transition","all 200ms");
           hovefun.closest("li").find("ul.grandchild").css("opacity","1");
           hovefun.closest("li").find("ul.grandchild").css("visibility","unset");
           hovefun.closest("li").find("ul.grandchild").css("z-index","0");

        }
        else{
        hovefun.parent('.side-draver-desk').removeClass('haschildren');

        }
  } );
   
    
   

  },
  function () {
   

 
   
   // $(this).closest("li").removeClass("result_hover_child");
      // $(this).closest('.side-draver-desk').removeClass('haschildren');
  }
);


$(document).ready(function() {
  $(".device-mobile ul.child li span.title-menus.cus-menu").click(function(e) {
    console.log('clicked');
    e.preventDefault();
  
    var hovefun = $(this);
    
    $('ul.child li.data-all-child.hide-list.list-menu__item.active.child-active.show-list').each(function(index,item){
          
      $(this).find(".second_layer_menu").html("");
       
    }).promise().done( function(){ 
      $("ul.grandchild").css("transform","translateX(-30px)");
      $("ul.grandchild").css("transition","all 150ms");
      $("ul.grandchild").css("opacity","0");
      $("ul.grandchild").css("visibility","hidden");
      $("ul.grandchild").css("z-index","0");
      $("ul.parent li a").removeClass("activehover");
      hovefun.closest("li").addClass("result_hover_child");     
      hovefun.closest("a").addClass("activehover");
    
      if ( hovefun.closest("li").find("ul.grandchild").length > 0 ) {
        hovefun.parent('.side-draver-desk').addClass('haschildren');
        hovefun.closest("li").find("ul.grandchild").css("transform","translateX(0px)");
        hovefun.closest("li").find("ul.grandchild").css("transition","all 200ms");
        hovefun.closest("li").find("ul.grandchild").css("opacity","1");
        hovefun.closest("li").find("ul.grandchild").css("visibility","unset");
        hovefun.closest("li").find("ul.grandchild").css("z-index","0");
      } else {
        hovefun.parent('.side-draver-desk').removeClass('haschildren');
      }
    });
    
  });
});


$(document).click(function(e){

      if($(e.target).parents('.side-draver-desk').length == 0 && $(e.target).parents('.list-menu--inline').length == 0){
          
      $('.side-draver-desk').removeClass('show-drawer');
      $('ul.child li.data-all-child.hide-list.list-menu__item.active.child-active.show-list').each(function(index,item){
        
        
       $(this).find("a").removeClass("activehover") ;

       $(this).find("ul.grandchild").css("transform","translateX(-30px)");
          $(this).find("ul.grandchild").css("transition","all 150ms");
           $(this).find("ul.grandchild").css("opacity","0");
           $(this).find("ul.grandchild").css("visibility","hidden");
          $(this).find("ul.grandchild").css("z-index","0");

        $(this).find(".second_layer_menu").html("");
     
      });

      

      $('body').removeClass('active-drawer');

      }

        if($("body").hasClass("template-collection-demo-progrm-via-api")){
          if($("body").hasClass("demoapiadd-pop")){
            
            if($(e.target).parents('.cart-error-drawer').length == 0 ){

              $(".cdel").removeClass("show-cdel");
              $(".quiz-main.product-variant").css('display','none');
              $('body').removeClass('demoapiadd-pop');
              $('body').removeClass('demorecomend-pop');
               $('body').removeClass('active-popup');

            }
          }else if($("body").hasClass("demoapi_cart-pop")){
            if($(e.target).parents('.cart-error-drawer').length == 0 ){
              $(".cdel").removeClass("show-cdel");
              $(".quiz-main.product-variant").css('display','none');
              $('body').removeClass('demoapi_cart-pop');
              $('body').removeClass('active-popup');
            }
          }else if($("body").hasClass("demorecomend-pop")){
            if($(e.target).parents('.quiz-pro-variant-inner').length == 0 ){
              
              $(".quiz-main.product-variant").css('display','none');
              $(".cdel").removeClass("show-cdel");
             $('body').removeClass('demoapiadd-pop');
             $('body').removeClass('demorecomend-pop');
              $('body').removeClass('active-popup');
            }
          }else{

             if($("body").hasClass("video_popup")){
                if($(e.target).parents('.video-sec-gel.pop-gel-vid.quiz-video-pop').length == 0 ){
                 $(".video-sec-gel.pop-gel-vid.quiz-video-pop").css("display","none");
                 $("body").removeClass("video_popup");
                 return false;
                }
             }else if($(e.target).parents('.quiz_step').length == 0 ){
              $(".quiz-main.quiz-questions").css('display','none');
              $('body').removeClass('active-pop');
            }
          }
          
        }

        if($("body").hasClass("template-product")){
          if($("body").hasClass("demoapi_cart-pop")){
            if($(e.target).parents('.cart-error-drawer').length == 0 ){
              $(".cdel").removeClass("show-cdel");
              $(".quiz-main.product-variant").css('display','none');
              $('body').removeClass('demoapi_cart-pop');
                 $('body').removeClass('active-popup');
            }
          }
        }



         if($(e.target).parents('.social-icon-popup-set').length == 0 ){

            if($("body").hasClass("social-pop")){
              if($(e.target).parents('.list-social__link').length == 0 ){
                  $(".sic-set.fb-set").css("display","none");
       
                  $(".sic-set.insta-set").css("display","none");
                  $(".sic-set.youtube-set").css("display","none");
                  $(".sic-set.tictok-set").css("display","none");
              }
             
              $(".social-icon-popup").removeClass("open-pops");
              $('body').removeClass('active-pop');
              $('body').removeClass('social-pop');
            }
          
        }
});

$(document).click(function(e){


   
      //if($(e.target).parents('.faq-popup').length == 0 && $(e.target).parents('.faq-popup').length == 0){
        if ( $(e.target).parents('.faq-popup-set').length != 0) {   
           setTimeout(function() {
             $(".faq-popup").css("display","block");
             $("body").addClass("opened_faq");
              $("body").addClass("active-popup");
          }, 500);


        }else if (e.target.id != '.faq-popup' && $(e.target).parents('.faq-popup').length == 0) { 

          if($("body").hasClass("opened_faq")){
             $('.faq-popup').css('display','none');
            $('body').removeClass('active-popup');
            $('body').removeClass('opened_faq');
          }
          
        }


        if (e.target.id != 'div#CartDrawer' && $(e.target).parents('div#CartDrawer').length == 0) { 
          //return false;

          
          if($("body").hasClass("drawer_open")){
              $('.cart-drawer').removeClass("cart-dra-opp");
              $('body').removeClass('active-popup');
              $('body').removeClass('drawer_open');
          }

          if($("div#ProductGridContainer").hasClass("open_new_demo")){
            $('.cart-drawer').addClass("cart-dra-opp");
              $('body').addClass('active-popup');
              $('body').addClass('drawer_open');
              // $("div#ProductGridContainer").removeClass("open_new_demo");
              setTimeout(function() {
           $("div#ProductGridContainer").removeClass("open_new_demo");
        }, 1000);
          }

           
          
        }

        if (e.target.id != '.demo-faq-popup' && $(e.target).parents('.demo-faq-popup').length == 0) { 

          if($("body").hasClass("add_faq_pop")){
               $(".demo-faq-popup").css("display","none");
            $('body').removeClass('active-pop');
             $('body').removeClass('add_faq_pop');
          }
          
        }
      
});

function demoProductCount(){
  let totalqty_tot = 0;
  $('.cart-drawer-min .cdmset').each(function(index,item){
    totalqty_tot = totalqty_tot + 1;
  });
  if(totalqty_tot == 0){
    if(!$(".cart-drawer-set").find(".nofound").length){
      $(".cart-drawer-last").css("display","none");
      $("div#globoCart").css("display","none");
      $(".cart-drawer-set").append('<div class="nofound"><h3>Your cart is empty</h3><a href="/collections/all" class="button">Continue Shopping</a></div>');
    }
  }
  if($('#product-grid').length > 0){
    $('#product-grid li .quick-add').find('.plus-cart-icon-msg').hide();
    $('div#recommend_demo ul#product-grid li .card > .card__inner .quick-add .added-item-msg').html('');
    $('ul#product-grid li .card > .card__inner .quick-add .added-item-msg').html('');
    // let qty_tot = $('.cart-drawer-min .cdmset').length;
    let newqty_tot = 1;
    $('.cart-drawer-min .cdmset').each(function(index,item){
      let dataitem = $(this).attr('data');
      if(dataitem){
        if((dataitem == 'DEMO'|| dataitem == 'demo'|| dataitem == 'Demo')){
          newqty_tot = newqty_tot + 1;
        }
      }
    });
    $('.cart-drawer-min .cdmset').each(function(index,item){
      let dataitem = $(this).attr('data');
      if(dataitem){
        if((dataitem == 'DEMO'|| dataitem == 'demo'|| dataitem == 'Demo')){
          let lineItemKey = $(this).find('.cdmsetr .pn-price-item').data('id');
          newqty_tot = newqty_tot - 1;
          let variantTitle = '';
          let variantTitle1 = 'is in your demo list.';
          if($.trim($(this).find('.cdminfo').text()) !==''){
            variantTitle = $(this).find('.cdminfo').text().replace('(STANDARD)','');
            variantTitle = variantTitle.replace('(Standard)','');
            variantTitle = 'Added: '+variantTitle.replace('(standard)','');
            variantTitle1 = '';
          } else{
            // variantTitle = $(this).find('.cdmtitle').text().replace('(STANDARD)','');
            // variantTitle = variantTitle.replace('(Standard)','');
            // variantTitle = variantTitle.replace('(standard)','');
            variantTitle = 'Added';
            variantTitle1 = '';
          }
          $('div#recommend_demo ul#product-grid li .card > .card__content .card__heading a:contains("'+$(this).find('.cdmtitle').text().trim()+'")').parents('.card__content').siblings('.card__inner').find('.quick-add').find('.added-item-msg').append('<span class="lineitem-data" data-key="'+lineItemKey+'"><span class="lineitem-title">'+variantTitle+'</span>&nbsp; '+variantTitle1+' (<span class="plus-icon-cart-count">'+newqty_tot+'&nbsp;</span> of 4)</span>');
          $('div#recommend_demo ul#product-grid li .card > .card__content .card__heading a:contains("'+$(this).find('.cdmtitle').text().trim()+'")').parents('.card__content').siblings('.card__inner').find('.quick-add').find('.plus-cart-icon-msg').show();
          $('ul#product-grid li .card > .card__content .card__heading a:contains("'+$(this).find('.cdmtitle').text().trim()+'")').parents('.card__content').siblings('.card__inner').find('.quick-add').find('.added-item-msg').append('<span class="lineitem-data" data-key="'+lineItemKey+'"><span class="lineitem-title">'+variantTitle+'</span>&nbsp; '+variantTitle1+' (<span class="plus-icon-cart-count">'+newqty_tot+'&nbsp;</span> of 4)</span>');
          $('ul#product-grid li .card > .card__content .card__heading a:contains("'+$(this).find('.cdmtitle').text().trim()+'")').parents('.card__content').siblings('.card__inner').find('.quick-add').find('.plus-cart-icon-msg').show();
        }
      }
    });
    //alert(qty_tot);
    let checkqty_tot = $('.cart-drawer-min .cdmset').length;
    //  alert(qty_tot);
       var newcount = 4 - parseInt(checkqty_tot) ;
      // alert(newcount);
            if(checkqty_tot == 4){
            var newquiztitle = '';
              if($("div#recommend_demo facet-filters-form").find(".facets.facets-vertical-sort.page-width.quiz-product-main-title")){
                 newquiztitle +=`
                    <h2>Nice! Let's wrap this up.</h2>
                    <div style="
    display: flex;
    margin-bottom: 35px;
    text-align: center;
    display: inline-grid;
" class="view_Cart_demoapi"><a href="/cart" style="
    width: 198px;
    height: 52px;
    /* left: 621px; */
    /* top: 266px; */

/* Black */
    background: #212120;
/* Grey */
    border: 0.5px solid #666666;
    padding-top: 15px;
    display: inline;
    color: white;
    text-decoration: none;
">View Cart</a>
                </div>`;
                $("div#recommend_demo .facets.facets-vertical-sort.page-width.quiz-product-main-title").html(newquiztitle);
              }else{
                 newquiztitle +=`<div class="facets facets-vertical-sort page-width quiz-product-main-title">
                    <h2>Nice! Let's wrap this up.</h2>
                    <div style="
    display: flex;
    margin-bottom: 35px;
    text-align: center;
    display: inline-grid;
" class="view_Cart_demoapi"><a href="/cart" style="
    width: 198px;
    height: 52px;
    /* left: 621px; */
    /* top: 266px; */

/* Black */
    background: #212120;
/* Grey */
    border: 0.5px solid #666666;
    padding-top: 15px;
    display: inline;
    color: white;
    text-decoration: none;
">View Cart</a></div>
                </div>`;
                $("div#recommend_demo facet-filters-form.facets.facets-vertical-sort.page-width.small-hide.no-js-hidden").prepend(newquiztitle);
              }
            }else if(checkqty_tot < 4 && checkqty_tot >= 0){

              var newquiztitle = '';
              if($("div#recommend_demo facet-filters-form").find(".facets.facets-vertical-sort.page-width.quiz-product-main-title")){
                 
                 newquiztitle +=`
                    <h2>Select <span id="quiz-product-count">${newcount}</span> paddles to try during the Demo Program.</h2>
                `;

                $("div#recommend_demo .facets.facets-vertical-sort.page-width.quiz-product-main-title").html(newquiztitle);
               // alert(newquiztitle);
              }else{
                 
                 newquiztitle +=`<div class="facets facets-vertical-sort page-width quiz-product-main-title">
                    <h2>Select <span id="quiz-product-count">${newcount}</span> paddles to try during the Demo Program.</h2>
                </div>`;
                
                $("div#recommend_demo facet-filters-form.facets.facets-vertical-sort.page-width.small-hide.no-js-hidden").prepend(newquiztitle);
                //alert(newquiztitle);
              }
           //  return false;
            }


    }
}




$('.shipping-popup-btn').click(function () {
	$('#shipping-popup').css("display", "block");;
});

$('.popup-closes').click(function () {
	$(this).parents('.cust-popup').css("display", "none");;
    $("body").removeClass('active-popup');
});

$('.popup-open-click, .shipping-popup-btn').click(function () {
	$("body").addClass('active-popup');
});


  let container = document.getElementById('shipping-popup');
   
    document.addEventListener('mouseup', function(e) {
    if (container) {
      if (!container.contains(e.target)) {
        container.style.display = 'none';
        $("body").removeClass("active-popup");
       // $("body").get(0).style.setProperty("--check-primary", "none");
      }
    }
});


$(document).on("click", ".single-option-selector label", function(){
  let selectorOption1 = $('[data-option="option1"]');
  let selectorOption2 = $('[data-option="option2"]');
  let selectorOption3 = $('[data-option="option3"]');
  let selectedAllOptions = true;

  setTimeout(function() {
    if (selectorOption1.length) {
      selectedAllOptions = false;
      var checkedElement = $('[data-option="option1"] input[type="radio"]:checked');
      if (checkedElement.length) {
        selectedAllOptions = true;
      }
    }

    if (selectedAllOptions == true) {
      if (selectorOption2.length) {
        selectedAllOptions = false;
        var checkedElement = $('[data-option="option2"] input[type="radio"]:checked');
        if (checkedElement.length) {
          selectedAllOptions = true;
        }
      } 
    }

    if (selectedAllOptions == true) {
      if (selectorOption3.length) {
        selectedAllOptions = false;
        var checkedElement = $('[data-option="option3"] input[type="radio"]:checked');
        if (checkedElement.length) {
          selectedAllOptions = true;
        }
      }
    }
  
    console.log(selectedAllOptions);
  
    setTimeout(function() {
      if (selectedAllOptions == true) {
        let selectedVariant = $('.product--large input[name="id"]').val()
        let selectedVarientMessage = $('.product-form__submit [variant-id="' + selectedVariant + '"]').attr('variant-id-message');
        $('.product-form__submit span').hide();
        $('.product-form__submit [variant-id="' + selectedVariant + '"]').show();
        $('[name="properties[Note]"]').val(selectedVarientMessage);
      }
    }, 100);  
  }, 50); 
  
});

$( document ).ready(function() {
    let selectorOption1 = $('[data-option="option1"]');
  let selectorOption2 = $('[data-option="option2"]');
  let selectorOption3 = $('[data-option="option3"]');
  let selectedAllOptions = true;

  setTimeout(function() {
    if (selectorOption1.length) {
      selectedAllOptions = false;
      var checkedElement = $('[data-option="option1"] input[type="radio"]:checked');
      if (checkedElement.length) {
        selectedAllOptions = true;
      }
    }

    if (selectedAllOptions == true) {
      if (selectorOption2.length) {
        selectedAllOptions = false;
        var checkedElement = $('[data-option="option2"] input[type="radio"]:checked');
        if (checkedElement.length) {
          selectedAllOptions = true;
        }
      } 
    }

    if (selectedAllOptions == true) {
      if (selectorOption3.length) {
        selectedAllOptions = false;
        var checkedElement = $('[data-option="option3"] input[type="radio"]:checked');
        if (checkedElement.length) {
          selectedAllOptions = true;
        }
      }
    }
  
    console.log(selectedAllOptions);
  
    setTimeout(function() {
      if (selectedAllOptions == true) {
        let selectedVariant = $('.product--large input[name="id"]').val()
        let selectedVarientMessage = $('.product-form__submit [variant-id="' + selectedVariant + '"]').attr('variant-id-message');
        $('.product-form__submit span').hide();
        $('.product-form__submit [variant-id="' + selectedVariant + '"]').show();
        $('[name="properties[Note]"]').val(selectedVarientMessage);
      }
    }, 100);  
  }, 50); 
  var urls = ["https:\/\/scripts.juniphq.com\/v1\/junip_shopify.js?shop=gearbox-sports.myshopify.com"];
  for (var i = 0; i < urls.length; i++) {
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = urls[i];
    var x = document.getElementsByTagName('script')[0];
    x.parentNode.insertBefore(s, x);
  }
});

document.addEventListener("DOMContentLoaded", function(event) {
  var hash = window.location.hash;
  if(hash == "#product-reviews") {
    const t = document.querySelector("#product-reviews");
    setTimeout(function() {
      t.scrollIntoView({
          behavior: "smooth"
      });
    }, 1000);  
    setTimeout(function() {
      t.scrollIntoView({
          behavior: "smooth"
      });
    }, 1200);  
  } 
});

document.addEventListener("DOMContentLoaded", function(event) {
  
  function refreshVariant() {
    document.addEventListener("change", function(e){
      const target = e.target.closest('form input[name="id"]');
      if(target){
        let selectedSizeElement = document.querySelector('fieldset[option-name="size"] input:checked');
        if (selectedSizeElement){
          let selectedSize = selectedSizeElement.value;
          document.querySelectorAll(".variant-picker .thumbnail-swatch").forEach(link => {
            var current = link.href.split('?')[0];
            link.href = current + '?sibSize=' + selectedSize;
          }); 
        }
      }
    });
  }

  refreshVariant();
});

document.addEventListener("DOMContentLoaded", function(event) {
  let urlParams = new URLSearchParams(window.location.search);
  let sizeParam = urlParams.get('sibSize');
  console.log(sizeParam);
  if (sizeParam) {
    document.querySelector('fieldset[option-name="size"] .form__label .swatch-name').textContent = sizeParam;
    document.querySelector('fieldset[option-name="size"] [data_more="' + sizeParam + '"]').click();
    document.querySelectorAll("variant-radios").forEach(selector => {
      selector.style.visibility = "visible";
    });
    document.querySelectorAll(".variant-picker .thumbnail-swatch").forEach(link => {
      var current = link.href.split('?')[0];
      link.href = current + '?sibSize=' + sizeParam;
    });
  } else {
    setTimeout(function() {
      document.querySelectorAll("variant-radios").forEach(selector => {
        selector.style.visibility = "visible";
      });
    }, 0);
  }
});


/**
 * Smoothly scrolls to an anchor target and compensates for lazy-loaded content layout shifts.
 */
function handleLazyLoadAnchorScroll() {
  const hash = window.location.hash;
  if (!hash) return;

  // Track the last known scroll execution to prevent overlapping animation cycles
  let scrollTimeout = null;
  let resizeObserver = null;
  let mutationObserver = null;

  function performScroll() {
    const targetElement = document.querySelector(hash);
    if (!targetElement) return false;

    // Use debouncing to prevent browser layout thrashing during smooth scrolls
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 50); // Small delay lets the browser calculate the newest layout position first

    return true;
  }

  // 1. Immediate execution attempt for cached or fast-loading elements
  const foundImmediately = performScroll();

  // 2. Set up a ResizeObserver to watch for layout height shifts (lazy-loaded images/frames)
  resizeObserver = new ResizeObserver(() => {
    if (document.querySelector(hash)) {
      performScroll();
    }
  });
  resizeObserver.observe(document.body);

  // 3. Fallback MutationObserver if the element itself hasn't been generated in the DOM yet
  if (!foundImmediately) {
    mutationObserver = new MutationObserver((mutations, obs) => {
      if (document.querySelector(hash)) {
        performScroll();
        obs.disconnect(); // Disconnect mutations once element is safely found
      }
    });
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  }

  // 4. Cleanup: Disconnect all observers after 7 seconds to keep memory pristine 
  setTimeout(() => {
    if (resizeObserver) resizeObserver.disconnect();
    if (mutationObserver) mutationObserver.disconnect();
  }, 1000);
}

// Event bindings
window.addEventListener('DOMContentLoaded', handleLazyLoadAnchorScroll);
window.addEventListener('hashchange', handleLazyLoadAnchorScroll);
